import {AfterViewInit, Component, ElementRef, NgZone, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {NotificationsService} from 'angular2-notifications';
import {UsuarioService} from 'src/app/services/usuario.service';
import {CustomSiteService} from '../../services/customsite.service';
import {ConfigurationService} from '../../services/configuration.service';

@Component({
    selector: 'app-senha',
    templateUrl: './senha.component.html',
    styleUrls: ['./senha.component.css']
})
export class SenhaComponent implements OnInit, AfterViewInit {
    @ViewChild('openModal', {static: true}) openModal: ElementRef;

    model: any = {};
    showSpinner = false;
    token = '';
  pageTitle = "Atendimento - Pagmob";

    constructor(private router: Router, private zone: NgZone, private usuarioService: UsuarioService, private route: ActivatedRoute, private _notificationService: NotificationsService, private customSiteService: CustomSiteService,
                private configService: ConfigurationService) { }

    ngOnInit() {
        this.route.queryParams.subscribe(params => {
            this.token = params['token'];
            this.usuarioService.validToken(this.token).subscribe(s => {
              if(s.valid) {
                if(s.confirmed) {
                  this._notificationService.success("Conta confirmada");
                  this.router.navigate(['/']);
                } else if(s.askPassword) this._notificationService.info("Insira nova senha");
              } else {
                this._notificationService.error("Link inválido");
                this.router.navigate(['/']);
              }
            });
          });
      const pageTitle = sessionStorage.getItem("pageTitle");
      if(pageTitle == null)
        this.configService.loadConfigurations().subscribe(config => {
          this.customSiteService.login(config.agencyId).subscribe(customsite => {
            if(customsite.pageTitle) {
              this.pageTitle = customsite.pageTitle;
              sessionStorage.setItem("pageTitle",this.pageTitle);
            }
            if(customsite.pageTitle) sessionStorage.setItem("loginText", customsite.loginText);
            if(customsite.loginObs) sessionStorage.setItem("loginObs", customsite.loginObs);
            if(customsite.popUp) sessionStorage.setItem("popUp", customsite.popUp);
            if(customsite.privacy) sessionStorage.setItem("privacy", customsite.privacy);
            if(customsite.termsAcceptance) sessionStorage.setItem("termsAcceptance", customsite.termsAcceptance);
            if(customsite.register) sessionStorage.setItem("register", customsite.register);
          });
        });
      else {
        this.pageTitle = pageTitle;
      }
    }

    ngAfterViewInit() {

    }

    enviarSenha() {
        if (this.model.senha != this.model.csenha) {
            this._notificationService.error('Ops!', 'A senha e a confirmação de senha estão diferentes. Favor redigitar.');
            return;
        }
        this.showSpinner = true;
        this.usuarioService.postNovaSenha(this.token, this.model.senha).subscribe(() => {
            this._notificationService.success('Alteração de senha', 'Senha alterada com sucesso.');
            const toast = this._notificationService.success('Alteração de senha', 'Redirecionando para o login, aguarde...');

            toast.timeoutEnd.subscribe(() => {
                this.zone.run(() => {
                    this.router.navigate(['/']);
                });
            });

            this.showSpinner = false;
        }, (err) => {
            this.showSpinner = false;
        });
    }

  testNumber(senha: string, csenha: string) {
    const regx = /\d/;
    return regx.test(senha) && regx.test(csenha);
  }
  testLetter(senha: string, csenha: string) {
    const regx = /[a-zA-Z]/;
    return regx.test(senha) && regx.test(csenha);
  }
  testSpecial(senha: string, csenha: string) {
    const regx = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
    return regx.test(senha) && regx.test(csenha);
  }
}
